import { api_get, api_post, stringfy_post } from '../utils/http'
import { listItem, userItem, poolItem, userTableItem } from '../../src/apps/settings/interface/'

const PREFIX = '/cguardian/api'

// 获取用户信息
async function getUserInfo(name: string) {
  try {
    const res = await api_get('/cguardian/api/users/get-user-info', {
      name
    })
    const { data, success } = res
    if (success) {
      return data
    }
  } catch (error) {
    throw new Error(error)
  }
}

// 获取当前登录用户信息
async function getCurrentUserInfo() {
  try {
    const res = await api_get('/cguardian/api/users/get-user-info', {})
    const { data, success } = res
    if (success) {
      return data
    }
  } catch (error) {
    throw new Error(error)
  }
}

// 修改当前登录用户电话
async function updateUserInfoTel(tel_no: string) {
  try {
    await stringfy_post('/cguardian/api/users/update-user-info', {
      tel_no
    })
  } catch (error) {
    throw new Error(error)
  }
}

// 修改当前登录用户邮箱
async function updateUserInfoEmail(email: string) {
  try {
    await stringfy_post('/cguardian/api/users/update-user-info', {
      email
    })
  } catch (error) {
    throw new Error(error)
  }
}

// 获取用户组列表
async function queryGroupList() {
  try {
    const res = await api_get('/cguardian/api/user-groups/query-group-list', {})
    const { data, success } = res
    let list: listItem[] = []
    if (success) {
      list = data.map((item: listItem, index: number) => {
        return {
          ...item,
          key: index
        }
      })
    }
    return list
  } catch (error) {
    throw new Error(error)
  }
}

// 获取用户组信息
async function queryGroupItem(id: string) {
  try {
    const res = await api_get(`/cguardian/api/user-groups/get-group-info`, {
      group_id: id
    })
    const { data, success } = res
    if (success) {
      return data
    }
  } catch (error) {
    throw new Error(error)
  }
}

// 获取用户组成员
async function queryUsers(group_id: string, page: number = 1, page_size: number = 10) {
  try {
    const res = await api_post('/cguardian/api/user-groups/query-users', {
      group_id,
      page,
      page_size
    })
    const { data, success } = res
    let list: userItem[] = []
    if (success) {
      list = data.records.map((item: any, index: number) => {
        return {
          key: String(index + 1),
          operation: '从用户组删除',
          ...item
        }
      })
    }
    return { list, total: data.total }
  } catch (error) {
    throw new Error(error)
  }
}

// 删除用户组里的用户
async function deleteUser(group_id: string, user_id: string) {
  try {
    await api_post('/cguardian/api/user-groups/delete-user', {
      group_id,
      user_id
    })
  } catch (error) {
    throw new Error(error)
  }
}

// 权限管理 / 添加多个用户
interface userListOptions {
  group_id: string
  page: number
  page_size: number
}
async function queryAllUserList(options: userListOptions) {
  console.log('权限管理 / 添加多个用户')
  const res = await api_get(`${PREFIX}/users/query-user-list`, options)
  const { data, success } = res
  let list = []
  if (success) {
    list = data.records.map((item: any, index: number) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
  }
  return {
    list,
    total: data.total
  }
}

// 获取所有备选用户
async function queryUserList(name: string, page: number, page_size: number = 10) {
  console.log('获取所有备选用户')
  const res = await api_get('/cguardian/api/users/query-user-list', {
    name,
    page,
    page_size
  })
  const { data, success } = res
  let list: poolItem[] = []
  if (success) {
    list = data.records.map((item: any, index: number) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
  }
  return {
    list,
    total: data.total
  }
}

interface allUsersOptions {
  name: string
  group_id: string
}
async function queryAllUsers(options: allUsersOptions) {
  const res = await api_get(`${PREFIX}/users/query-all-users`, options)
  const { data, success } = res
  let list = []
  if (success) {
    list = data.records.map((item, index) => {
      return {
        key: String(index + 1),
        ...item
      }
    })
  }
  return {
    list,
    total: list.length
  }
}

// 添加用户
async function addUsers(group_id: string, user_ids: any[]) {
  const res = await stringfy_post('/cguardian/api/user-groups/add-users', {
    group_id,
    user_ids
  })
  return res
}

// 获取用户权限列表
interface permOptions {
  search: string
  filter: string
  group_id: string
  page: number
  page_size: number
}
async function queryPermList(options: permOptions) {
  const res = await api_post(`${PREFIX}/user-groups/query-perm-list`, options)
  const { data, success } = res
  let list = []
  if (success) {
    list = data.records.map((item: any, index: number) => {
      return {
        key: index,
        ...item
      }
    })
  }
  return {
    list,
    total: data.total
  }
}

// 改变权限
interface changePermOptions {
  tags: string[] // 标签数组
  req_id: string // URL ID
  group_id: string // 用户组 ID
  is_selected: string // 当前这一条权限是否启用，启用传1， 不启用传0
}
async function changePerms(options: changePermOptions) {
  const res = await stringfy_post(`${PREFIX}/user-groups/change-perms`, options)
}

// queryUserList
async function queryUserListWithGroup(name: string, page: number, page_size: number = 10) {
  console.log('queryUserList')
  const res = await api_get('/cguardian/api/users/query-user-list', {
    name,
    page,
    page_size
  })
  const { data, success } = res
  let list: userTableItem[] = []
  if (success) {
    list = data.records.map((item: any, index: number) => {
      return {
        key: String(index + 1),
        groupString: item.groups.join('/'),
        ...item
      }
    })
  }
  return { list, total: data.total }
}

// 获取用户不在的哪个组
async function queryCurrentUserGroupList(id: string) {
  try {
    const res = await api_get(`/cguardian/api/user-groups/query-group-list?user_id=${id}`, {})
    const { data, success } = res
    let list = []
    if (success) {
      list = data.map((item: any) => {
        return {
          label: item.name,
          value: item.id,
          checked: item.checked
        }
      })
    }
    return list
  } catch (error) {
    throw new Error(error)
  }
}

// 更新用户所在群组
async function updateUserGroup(group_ids: string, user_id: string) {
  try {
    const res = await api_post('/cguardian/api/users/update-user-group', {
      group_ids,
      user_id
    })
  } catch (error) {
    throw new Error(error)
  }
}

// 获取用户和组的关系
interface groupOptions {
  user_id: string
}
async function queryGroups(options: groupOptions) {
  const res = await api_post(`${PREFIX}/users/query-groups`, options)
  const { data, success } = res
  let list = []
  if (success) {
    list = data
  }
  return list
}

// 改变用户状态
async function changeUserStatus(action: string, user_ids: string[]) {
  try {
    const res = await stringfy_post('/cguardian/api/users/change-user-status', {
      action,
      user_ids
    })
  } catch (error) {
    throw new Error(error)
  }
}

// 获取所有备选用户

// 违规类型
const illegalTypes = [
  [1, '涉黄'],
  [2, '涉毒'],
  [3, '涉赌'],
  [4, '涉暴'],
  [5, '涉恐'],
  [6, '涉政'],
  [7, '其他']
]

function getIllegalTypes(array: Array<any>) {
  let ret = new Array<Array<any>>()
  Object.assign(ret, illegalTypes)
  ret.unshift(array)
  return ret
}

export {
  getIllegalTypes,
  getUserInfo,
  queryGroupList,
  queryGroupItem,
  queryUsers,
  deleteUser,
  queryAllUsers,
  addUsers,
  queryPermList,
  changePerms,
  queryUserListWithGroup,
  queryCurrentUserGroupList,
  updateUserGroup,
  changeUserStatus,
  getCurrentUserInfo,
  updateUserInfoTel,
  updateUserInfoEmail,
  queryAllUserList,
  queryGroups,
  illegalTypes
}
